import { render, staticRenderFns } from "./BoosthermWidgetComponent.vue?vue&type=template&id=019bed64&"
import script from "./BoosthermWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./BoosthermWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports